module.exports = __webpack_public_path__ + "img/BocataVizcaina_blur.32d6788d.jpg";